// Copyright © 2019-2026 Focal Systems. All rights reserved.

/**
 * Base tab title. Non-production builds carry their env in parentheses so a
 * staging tab is never mistaken for production.
 */
const appEnv = import.meta.env.VITE_APP_ENV;

export const BASE_DOCUMENT_TITLE = appEnv && appEnv !== "production" ? `Back Office (${appEnv})` : "Back Office";

/**
 * `Back Office (staging) · Chains · ASDA` — the product name stays first so tabs
 * remain recognisable when the browser truncates them, followed by the same
 * breadcrumb trail the in-app header shows. Blank segments are dropped.
 */
export function documentTitleFor(segments: (string | undefined)[] = []) {
  const trail = segments.map((segment) => segment?.trim()).filter(Boolean);
  return [BASE_DOCUMENT_TITLE, ...trail].join(" · ");
}
